module.exports = __webpack_public_path__ + "img/DSimage.2ad7102d.png";